export { default } from "./FeaturedStrainCard";
